<template>
    <b-form-group
        label="Тип отчета:"
        label-for="typeSelect"
        :label-cols="3"
        :invalid-feedback="invalid_feedback"
        :state="validation_state"
    >
        <b-form-radio-group
            :id="'dateTypeSelect'+uid"
            stacked
            :name="'radio-validation'+uid"
        >
            <div class="custom-control custom-radio" v-for="t in types">
                <input
                    type="radio"
                    :id="'reportType_'+uid+t"
                    name="reportType"
                    class="custom-control-input"
                    :value="t"
                    :state="validation_state"
                    v-model="_type"
                >
                <label class="custom-control-label" :for="'reportType_'+uid+t">{{type_names[t]}}</label>
            </div>
        </b-form-radio-group>
    </b-form-group>
</template>

<script>
    import {random} from "../shared/utils";

    export default {
        name: "ReportTypes",
        data: function() {
            return {
                type_names: {
                    detailed: 'Детальный',
                    grouped: 'Сводка',

                    groupbyagent: 'Сводка по агентам',
                    groupbyagentcompact: 'Сводка по агентам - компактный',
                    groupbycity: 'Сводка по городам',
                    groupbyhotel: 'Сводка по объектам',
                    groupbyagentcity: 'Сводка по агентам/городам',
                    groupbyagenthotel: 'Сводка по агентам/объектам',
                    active_finished: 'Исполняемые и исполненные',
                    annulaed: 'Только аннулированные',

                    errors_no_bookings: 'Нет бронирования',
                    errors_multiple_bookings: 'Множественные бронирования',
                    errors_no_payment_date: 'Нет даты оплаты путевки (для объектов с вознаграждением по дате оплаты счета объекта)',
                    errors_no_payment_date_all: 'Нет даты оплаты путевки (для всех объектов)',

                    payment_all: 'Все',
                    payment_bank: 'Банк',
                    payment_cash: 'Касса',
                },
                uid: random(0,2000000000)
            }
        },
        props: {
            type: String,
            types: Array,
            validation_state:Boolean,
            invalid_feedback: String,
        },
        model: {
            prop: "type",
            event: "input"
        },
        computed: {
            _type: {
                get: function() {
                    return this.type
                },
                set: function (val) {
                    this.$emit("input", val);
                }
            }
        }
    }
</script>
